import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-faqs',
  templateUrl: './edit-faqs.component.html',
  styleUrls: ['./edit-faqs.component.scss']
})
export class EditFaqsComponent implements OnInit {

    productId: string | null = null;


 product: any = {

question_ar: "...",
  question_en: "...",
  answer_ar: "...",
  answer_en: "..."
};




constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,private translate: TranslateService
  ) {}
    ngOnInit(): void {
    // get product id from route
    this.productId = this.route.snapshot.paramMap.get('id');

    if (this.productId) {
      this.loadProduct(this.productId);
    }
  }

  // Fetch product details (create an API if not exists)
 loadProduct(id: string): void {
    this.apiService.getFaqById(id).subscribe({
      next: (res: any) => {
        this.product = res.data || this.product;
      },
      error: (err) => {
        console.error('Failed to load product:', err);
        // this.toastr.error('Failed to load product details');
      },
    });
  }

    onFileSelected(event: any): void {
    if (event.target.files.length > 0) {
      this.product.image = event.target.files[0];
    }
  }
  // Update product

updateProduct(): void {
  if (!this.productId) return;

  this.apiService.editFaq(
    this.productId,
    this.product.question_ar,
    this.product.question_en,
    this.product.answer_ar,
    this.product.answer_en
  ).subscribe({
    next: () => {
      this.toastr.success(this.translate.instant('MENU.DASHBOARD.faq_updated_successfully'));
      this.router.navigate(['/frequently']);
    },
    error: (err) => {
      console.error('Update failed:', err);
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_update_faq'));
    }
  });
}
 

  // updateProductt(): void {
  //   if (!this.productId) return;

  //   if (
  //     this.product.password &&
  //     this.product.password !== this.product.password_confirmation
  //   ) {
  //     this.toastr.error('Passwords do not match');
  //     return;
  //   }

  //   const form = new FormData();
  //   form.append('name', this.product.name);
  //   form.append('email', this.product.email);
  //   form.append('mobile', this.product.mobile);

  //   if (this.product.password) {
  //     form.append('password', this.product.password);
  //     form.append('password_confirmation', this.product.password_confirmation);
  //   }

  //   if (this.product.image) {
  //     form.append('image', this.product.image);
  //   }

  //   this.apiService.editreproductions(this.productId, form).subscribe({
  //     next: () => {
  //       this.toastr.success('User updated successfully');
  //       this.router.navigate(['/users']);
  //     },
  //     error: (err) => {
  //       console.error('Update failed:', err);
  //       this.toastr.error('Failed to update user');
  //     }
  //   });
  // }

}